<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
                        camera</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Tên:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input placeholder="Tên camera..." v-model="search.cTen" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>IP:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input placeholder="IP..." v-model="search.cIp" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="-1"></el-option>
                                    <el-option label="Hoạt động" value="1"></el-option>
                                    <el-option label="Đã xóa" value="0"></el-option>
                                </el-select>
                            </el-col>
                        <!-- </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Loại:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.cLoai" :clearable="false">
                                    <el-option label="Tất cả" value=""></el-option>
                                    <el-option label="Cộng đồng" value="PUBLIC"></el-option>
                                    <el-option label="Cá nhân" value="PRIVATE"></el-option>
                                </el-select>
                            </el-col> -->
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_camera">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm camera</span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMaCamera" label="Mã" width="70" align="center"></el-table-column>
                        <el-table-column prop="cTen" label="Tên camera" min-width="150" header-align="center">

                        </el-table-column>
                        <el-table-column prop="cIp" label="IP" align="center" width="150">
                            <template #default="scope">
                                {{ scope.row.cIp }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="cUrl" label="URL" align="center" width="150">
                            <template #default="scope">
                                {{ scope.row.cUrl }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="cLoai" label="Loại" width="100" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.cLoai == 'PUBLIC'" size="small">Công
                                    cộng</el-tag>
                                <el-tag type="warning" v-if="scope.row.cLoai == 'PRIVATE'" size="small">Cá nhân</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">
                            <template #default="scope">
                                <span v-if="scope.row.dNgayTao">{{
                                    momentDate(scope.row.dNgayTao)
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column label="Hành động" align="center" width="150">
                            <template #default="scope">

                                <!--  <el-button type="primary" :disabled="scope.row.nTinhTrang == 0">
                                <span class="btn-inner--icon"><i class="fa fa-play position-static"></i></span>
                            </el-button> -->

                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_camera">
                                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                </el-button>

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_camera" ref="cameraModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_camera_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ !operation ? "Thêm camera" : "Cập nhật camera" }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px"
                            class=" d-flex flex-column">
                            <el-form-item label="Tên Camera" prop="cTen">
                                <el-input v-model="formData.cTen" />
                            </el-form-item>
                            <el-form-item label="Phương thức kết nối" prop="">
                                <el-radio-group v-model="isIP" @change="handleChangeType">
                                    <el-radio :value="true">IP</el-radio>
                                    <el-radio :value="false">Đường dẫn</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="Địa chỉ IP" prop="cIp" v-if="isIP">
                                <el-input v-model="formData.cIp" />
                            </el-form-item>
                            <el-form-item label="Tài khoản" prop="cTaiKhoan" v-if="isIP">
                                <el-input v-model="formData.cTaiKhoan" />
                            </el-form-item>
                            <el-form-item label="Mật khẩu" prop="cMatKhau" v-if="isIP">
                                <el-input v-model="formData.cMatKhau" type="password" show-password/>
                            </el-form-item>
                            <el-form-item label="Đường dẫn" prop="cUrl" v-else>
                                <el-input v-model="formData.cUrl" />
                            </el-form-item>
                            <!-- <el-form-item label="Loại camera" prop="cLoai">
                                <el-select placeholder="Chọn loại camera" v-model="formData.cLoai" style="width: 30%;">
                                    <el-option label="Công cộng" :value="'PUBLIC'"></el-option>
                                    <el-option label="Cá nhân" :value="'PRIVATE'"></el-option>
                                </el-select>
                            </el-form-item> -->
                            <!-- <el-form-item label="Banner" prop="bannerFile">
                                <el-upload action="#" list-type="picture-card" :auto-upload="false"
                                    placeholder="Chọn banner" ref="upload" :file-list="bannerFile"
                                    :on-change="handleChangeFile" :on-remove="handleRemoveFile">
                                    <div class="d-flex align-items-center justify-content-center w-100 h-100">
                                        <i class="el-icon-plus" v-if="bannerFile.length == 0"></i>
                                        <i class="el-icon-refresh" v-if="bannerFile.length > 0"></i>
                                    </div>
                                </el-upload>
                            </el-form-item> -->
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Thêm</el-button>
                            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Lưu</el-button>
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div v-if="openIframe" class="d-flex position-absolute z-index-2 h-100 w-100 bg-dark">
            <div class="position-absolute p-4 z-index-3 d-flex  align-items-center ">
                <span class="closeIframe cursor-pointer fs-2 fw-bolder text-white" @click="handleCLoseIframe"><i
                        class="fa fa-arrow-left pe-2"></i>Trở lại</span>
            </div>
            <div id="iframeLoading"
                class="h-100 w-100 d-flex justify-content-center align-items-center position-absolute z-index-1">
                <div class="spinner-border text-primary h-150px w-150px" role="status">
                </div>
            </div>
            <iframe :src="iframeURL" class="d-flex position-absolute z-index-2 h-100 w-100" id="cameraIframe">
            </iframe>
        </div> -->
    </div>
</template>
<script>
import { Cameras } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
export default {
    name: 'camera',
    data() {
        return {
            search: {
                cTen: "",
                cLoai: "PUBLIC",
                cIp: "",
                nTinhTrang: "-1",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1,
                type: 1
            },
            formData: {
                cTen: "",
                cIp: "",
                cUrl: "",
                cLoai: "PUBLIC",
                cTaiKhoan: "",
                cMatKhau: "",
                /* bannerFile: [] */
            },
            rules: {
                cTen: [{ required: true, message: "Xin vui lòng điền tên camera", trigger: "blur" }],
                cIp: [{ required: true, message: "Xin vui lòng điền IP", trigger: "blur" }],
                cTaiKhoan: [{ required: true, message: "Xin vui lòng điền tài khoản", trigger: "blur" }],
                cMatKhau: [{ required: true, message: "Xin vui lòng điền mật khẩu", trigger: "blur" }],
                cUrl: [{ required: true, message: "Xin vui lòng điền đường dẫn", trigger: "blur" }],
                /* cLoai: [{ required: true, message: "Xin vui lòng chọn loại camera", trigger: "blur" }], */

            },
            tableData: {
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
            isIP: false,
            /* bannerFile: [], */
            baseUrl: baseUrl
        }
    },
/*     watch: {
        modalVisible() {
            if (!this.modalVisible) {
                this.bannerFile = []
            }
        }
    }, */
    methods: {
        handleChangeType(){
            this.formData.cUrl = ""
            this.formData.cIp= ""
            this.formData.cTaiKhoan= ""
            this.formData.cMatKhau= ""
        },
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {}
        },
        handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
            if(val.cIp){
                this.isIP = true
            }
            /* if (val.cBienHieu) {
                this.addImageFromURL(baseUrl + val.cBienHieu)
            } */
        },
        handleClose() {
            this.modalVisible = false
            hideModal(this.$refs.cameraModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa camera này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(Cameras.deleteCamerasById, val.nMaCamera).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa camera thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa camera thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleCLoseIframe() {
            this.openIframe = false
            this.iframeURL = ""
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTen: { value: this.search.cTen },
                cLoai: { value: this.search.cLoai },
                cIp: { value: this.search.cIp },
                nTinhTrang: { value: this.search.nTinhTrang },
            }
            this.store.dispatch(Cameras.findPageCamera, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            })
        },
/*         async handleChangeFile(file, bannerFile) {
            this.bannerFile = [file]
            this.formData.bannerFile = this.bannerFile
            this.formData.cBienHieu = file.name
        },
        handleRemoveFile(file, bannerFile) {
            this.formData.bannerFile = []
            this.formData.bannerFile = this.bannerFile
            this.formData.cBienHieu = null
        },
        addImageFromURL(url) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "image.jpg", { type: blob.type });
                    this.bannerFile.push({
                        name: file.name,
                        url: URL.createObjectURL(file),
                        status: 'success',
                        uid: Date.now(),
                        raw: file
                    });
                });
        }, */
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu camera này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                        .then(() => {
                            const data = {
                                cTen: this.formData.cTen,
                                cUrl: this.formData.cUrl,
                                cIp: this.formData.cIp,
                                nTinhTrang: 1,
                                cLoai: "PUBLIC",
                                cTaiKhoan:this.formData.cTaiKhoan,
                                cMatKhau:this.formData.cMatKhau
                            }
                            const formData = new FormData();
                            if (this.operation) {
                                data.id = this.formData.nMaCamera
                                formData.append('cameraRequest', new Blob([JSON.stringify(data)], { type: "application/json" }));
                                this.store.dispatch(Cameras.updateCameras, { id: data.id, data: formData }).then(res => {
                                    if (res.code == 200) {
                                        ElMessage({ message: "Cập nhật camera thành công", type: "success" });
                                        this.handleClose()
                                        this.handleFindPage()
                                    }
                                    else {
                                        ElMessage({ message: res.msg, type: "error" });
                                    }
                                }).catch((error) => {
                                    ElMessage({ message: "Cập nhật thất bại", type: "error" });
                                })
                            } else {
                                formData.append('cameraRequest', new Blob([JSON.stringify(data)], { type: "application/json" }));
                                this.store.dispatch(Cameras.saveCameras, formData).then(res => {
                                    if (res.code == 200) {
                                        ElMessage({ message: "Thêm camera thành công", type: "success" });
                                        this.handleClose()
                                        this.handleFindPage()
                                    }
                                    else {
                                        ElMessage({ message: res.msg, type: "error" });
                                    }
                                }).catch((error) => {
                                    ElMessage({ message: "Thêm thất bại", type: "error" });
                                })
                            }
                        }).catch(() => {

                        })
            })
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>